/* eslint-disable */
import {
    GET_GRIEVANCE_LIST_WITH_PAGINATION,
    SET_ADMIN_GRIEVANCE_SINGLE_LIST,
    SET_ADMIN_NAVIGATION_SIDEBAR_PANEL,
    SET_ADMIN_UNIVERSITY_STATES,
    SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN,
    SET_ALL_DISTRICT, SET_ALL_DISTRICT_PAGE_NO_COUNTER,
    SET_ALL_DISTRICT_STATES,
    SET_ALL_EXAMSUBJECTS, SET_ALL_EXAMSUBJECT_PAGE_NO_COUNTER,
    SET_ALL_INSTITUTION, SET_ALL_INSTITUTION_DROPDOWN, SET_ALL_INSTITUTION_PAGE_NO_COUNTER,
    SET_ALL_REQDEPARTMENTS, SET_ALL_REQDEPARTMENT_PAGE_NO_COUNTER,
    SET_ALL_REQUISITIONPOST, SET_ALL_REQUISITIONPOST_PAGE_NO_COUNTER,
    SET_ALL_SPECIALIZATION, SET_ALL_SPECIALIZATION_PAGE_NO_COUNTER,
    SET_ALL_STAGES, SET_ALL_STAGES_PAGE_NO_COUNTER,
    SET_ALL_STATES, SET_ALL_STATES_PAGE_NO_COUNTER,
    SET_ALL_TALUKA,
    SET_ALL_TALUKA_DISTRICTS,
    SET_ALL_TALUKA_PAGE_NO_COUNTER,
    SET_ALL_TALUKA_STATES,
    SET_ALL_VILLAGE,
    SET_ALL_VILLAGE_DISTRICTS,
    SET_ALL_VILLAGE_PAGE_NO_COUNTER,
    SET_ALL_VILLAGE_STATES,
    SET_ALL_VILLAGE_TALUKAS,
    SET_DISTRICT,
    SET_DOCUMENT_TYPE_PAGE_NO_COUNTER,
    SET_EXAMSUBJECT,
    SET_GET_ALL_DOCUMENTS_TYPE,
    SET_GET_ALL_QUALIFICATION_NAME,
    SET_GET_ALL_QUALIFICATION_TYPE,
    SET_GET_DOCUMENTS_TYPE,
    SET_GET_QUALIFICATION_NAME,
    SET_GET_QUALIFICATION_TYPE,
    SET_INSTITUTION,
    SET_LOOKUP_OPTION,
    SET_LOOKUP_OPTIONS, SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER,
    SET_MODULES_LIST,
    SET_PARENT_EXAMSUBJECT_DATA,
    SET_PARENT_LABELS_LIST,
    SET_PARENT_LOOKUP_DATA, SET_PARENT_TYPE_LIST,
    SET_QUALIFICATION_NAMES,
    SET_QUALIFICATION_NAMES_COMBO,
    SET_QUALIFICATION_NAME_PAGE_NO_COUNTER,
    SET_QUALIFICATION_SUBJECT,
    SET_QUALIFICATION_SUBJECTS,
    SET_QUALIFICATION_SUBJECTS_PAGE_NO_COUNTER,
    SET_QUALIFICATION_TYPES,
    SET_QUALIFICATION_TYPES_COMBO,
    SET_QUALIFICATION_TYPE_PAGE_NO_COUNTER,
    SET_REPORT_RANGE,
    SET_REQDEPARTMENT,
    SET_REQUISITIONPOST,
    SET_SPECIALIZATION,
    SET_STAGE,
    SET_STATE,
    SET_TALUKA,
    SET_TYPES_LIST,
    SET_UNIVERSITIES, SET_UNIVERSITIES_PAGE_NO_COUNTER,
    SET_UNIVERSITY,
    SET_VILLAGE
} from "../../../common/constants/ActionTypes"



const initialState = {
    documentListDetails: [],
    documentTypeDetails: {},
    qualificationListDetails: [],
    qualificationTypeDetails: {},
    qualificationNameListDetails: [],
    qualificationNameDetails: {},
    qualificationNamesCombo: [],
    qualificationTypesCombo: [],
    qualificationSubject: [],
    qualificationSubjectNames: [],
    qualificationSubjectPageNoCounter: 0,

    universityStates: [],
    universitiesList: [],
    universityPageNoCounter: 0,
    universityData: {},

    modulesList: [],
    typesList: [],
    parentLabelsList: [],
    lookupOptionData: {},
    lookupOptionsList: [],
    parentTypeList: [],
    parentLookupData: {},
    lookupOptionPageNoCounter: 0,
    stateData: {},
    statesListData: [],
    statePageNoCounter: 0,

    districtStatesList: [],
    districtList: [],
    districtPageNoCounter: 0,
    districtDetails: {},

    examSubjectData: {},
    examSubjectsListData: [],
    parentExamsubjectData: [],
    examSubjectPageNoCounter: 0,

    talukaStatesList: [],
    talukaDistrictsList: [],
    talukaList: [],
    talukaPageNoCounter: 0,
    talukaDetails: {},

    villageStatesList: [],
    villageDistrictsList: [],
    villageTalukasList: [],
    villageList: [],
    villagePageNoCounter: 0,
    villageDetails: {},


    stageData: {},
    stageListData: [],
    stagePageNoCounter: 0,
    specialisationData: {},
    specialisationListData: [],
    specialisationPageNoCounter: 0,

    requisitionPostData: {},
    requisitionPostListData: [],
    requisitionPostPageNoCounter: 0,

    requisitionDepartmentData: {},
    requisitionDepartmentListData: [],
    requisitionDepartmentPageNoCounter: 0,
    institutionData: {},
    institutionListData: [],
    institutionPageNoCounter: 0,
    administrativeDepartmentData: [],
    grievanceList: [],
    singleGrievanceDetail: {},
    navigationpanelList: [],
    reportRange: ""

}

export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case SET_GET_ALL_DOCUMENTS_TYPE:
            return {
                ...state,
                documentListDetails: action.payload
            }
        case SET_GET_DOCUMENTS_TYPE:
            return {
                ...state,
                documentTypeDetails: action.payload
            }
        case SET_DOCUMENT_TYPE_PAGE_NO_COUNTER:
            return {
                ...state,
                documentTypePageNoCounter: action.payload
            }

        case SET_GET_ALL_QUALIFICATION_TYPE:
            return {
                ...state,
                qualificationListDetails: action.payload
            }
        case SET_GET_QUALIFICATION_TYPE:
            return {
                ...state,
                qualificationTypeDetails: action.payload
            }
        case SET_QUALIFICATION_TYPE_PAGE_NO_COUNTER:
            return {
                ...state,
                qualificationTypePageNoCounter: action.payload
            }
        case SET_GET_ALL_QUALIFICATION_NAME:
            return {
                ...state,
                qualificationNameListDetails: action.payload
            }
        case SET_GET_QUALIFICATION_NAME:
            return {
                ...state,
                qualificationNameDetails: action.payload
            }
        case SET_QUALIFICATION_NAME_PAGE_NO_COUNTER:
            return {
                ...state,
                qualificationNamePageNoCounter: action.payload
            }
        case SET_QUALIFICATION_TYPES:
            return {
                ...state,
                qualificationTypes: action.payload
            }
        case SET_QUALIFICATION_TYPES_COMBO:
            return {
                ...state,
                qualificationTypesCombo: action.payload
            }
        case SET_QUALIFICATION_NAMES_COMBO:
            return {
                ...state,
                qualificationNamesCombo: action.payload
            }
        case SET_QUALIFICATION_NAMES:
            return {
                ...state,
                qualificationNames: action.payload
            }
        case SET_QUALIFICATION_SUBJECTS:
            return {
                ...state,
                qualificationSubjectNames: action.payload
            }
        case SET_QUALIFICATION_SUBJECTS_PAGE_NO_COUNTER:
            return {
                ...state,
                qualificationSubjectPageNoCounter: action.payload
            }
        case SET_QUALIFICATION_SUBJECT:
            return {
                ...state,
                qualificationSubject: action.payload
            }
        case SET_ADMIN_UNIVERSITY_STATES:
            return {
                ...state,
                universityStates: action.payload
            }
        case SET_UNIVERSITY:
            return {
                ...state,
                universityData: action.payload
            }
        case SET_UNIVERSITIES:
            return {
                ...state,
                universitiesList: action.payload
            }
        case SET_UNIVERSITIES_PAGE_NO_COUNTER:
            return {
                ...state,
                universityPageNoCounter: action.payload
            }
        case SET_LOOKUP_OPTIONS:
            return {
                ...state,
                lookupOptionsList: action.payload
            }
        case SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER:
            return {
                ...state,
                lookupOptionPageNoCounter: action.payload
            }
        case SET_LOOKUP_OPTION:
            return {
                ...state,
                lookupOptionData: action.payload
            }
        case SET_MODULES_LIST:
            return {
                ...state,
                modulesList: action.payload
            }
        case SET_TYPES_LIST:
            return {
                ...state,
                typesList: action.payload
            }
        case SET_PARENT_LABELS_LIST:
            return {
                ...state,
                parentLabelsList: action.payload
            }
        case SET_PARENT_TYPE_LIST:
            return {
                ...state,
                parentTypeList: action.payload
            }
        case SET_PARENT_LOOKUP_DATA:
            return {
                ...state,
                parentLookupData: action.payload
            }
        case SET_ALL_STATES:
            return {
                ...state,
                statesListData: action.payload
            }
        case SET_ALL_STATES_PAGE_NO_COUNTER:
            return {
                ...state,
                statePageNoCounter: action.payload
            }
        case SET_STATE:
            return {
                ...state,
                stateData: action.payload
            }
        case SET_ALL_DISTRICT_STATES:
            return {
                ...state,
                districtStatesList: action.payload
            }
        case SET_DISTRICT:
            return {
                ...state,
                districtDetails: action.payload
            }
        case SET_ALL_DISTRICT:
            return {
                ...state,
                districtList: action.payload
            }
        case SET_ALL_DISTRICT_PAGE_NO_COUNTER:
            return {
                ...state,
                districtPageNoCounter: action.payload
            }
        case SET_ALL_TALUKA_STATES:
            return {
                ...state,
                talukaStatesList: action.payload
            }
        case SET_ALL_TALUKA_DISTRICTS:
            return {
                ...state,
                talukaDistrictsList: action.payload
            }
        case SET_TALUKA:
            return {
                ...state,
                talukaDetails: action.payload
            }
        case SET_ALL_TALUKA:
            return {
                ...state,
                talukaList: action.payload
            }
        case SET_ALL_TALUKA_PAGE_NO_COUNTER:
            return {
                ...state,
                talukaPageNoCounter: action.payload
            }
        case SET_ALL_VILLAGE_STATES:
            return {
                ...state,
                villageStatesList: action.payload
            }
        case SET_ALL_VILLAGE_DISTRICTS:
            return {
                ...state,
                villageDistrictsList: action.payload
            }
        case SET_ALL_VILLAGE_TALUKAS:
            return {
                ...state,
                villageTalukasList: action.payload
            }
        case SET_VILLAGE:
            return {
                ...state,
                villageDetails: action.payload
            }
        case SET_ALL_VILLAGE:
            return {
                ...state,
                villageList: action.payload
            }
        case SET_ALL_VILLAGE_PAGE_NO_COUNTER:
            return {
                ...state,
                villagePageNoCounter: action.payload
            }
        case SET_PARENT_EXAMSUBJECT_DATA:
            return {
                ...state,
                parentExamsubjectData: action.payload
            }
        case SET_ALL_EXAMSUBJECTS:
            return {
                ...state,
                examSubjectsListData: action.payload
            }
        case SET_ALL_EXAMSUBJECT_PAGE_NO_COUNTER:
            return {
                ...state,
                examSubjectPageNoCounter: action.payload
            }
        case SET_EXAMSUBJECT:
            return {
                ...state,
                examSubjectData: action.payload
            }
        case SET_ALL_SPECIALIZATION:
            return {
                ...state,
                specialisationListData: action.payload
            }
        case SET_ALL_STAGES:
            return {
                ...state,
                stageListData: action.payload
            }
        case SET_ALL_STAGES_PAGE_NO_COUNTER:
            return {
                ...state,
                stagePageNoCounter: action.payload
            }
        case SET_STAGE:
            return {
                ...state,
                stageData: action.payload
            }
        case SET_ALL_SPECIALIZATION_PAGE_NO_COUNTER:
            return {
                ...state,
                specialisationPageNoCounter: action.payload
            }
        case SET_SPECIALIZATION:
            return {
                ...state,
                specialisationData: action.payload
            }
        case SET_ALL_REQUISITIONPOST:
            return {
                ...state,
                requisitionPostListData: action.payload
            }
        case SET_ALL_REQUISITIONPOST_PAGE_NO_COUNTER:
            return {
                ...state,
                requisitionPostPageNoCounter: action.payload
            }
        case SET_REQUISITIONPOST:
            return {
                ...state,
                requisitionPostData: action.payload
            }
        case SET_ALL_REQDEPARTMENTS:
            return {
                ...state,
                requisitionDepartmentListData: action.payload
            }
        case SET_ALL_REQDEPARTMENT_PAGE_NO_COUNTER:
            return {
                ...state,
                requisitionDepartmentPageNoCounter: action.payload
            }
        case SET_REQDEPARTMENT:
            return {
                ...state,
                requisitionDepartmentData: action.payload
            }
        case SET_ALL_INSTITUTION:
            return {
                ...state,
                institutionListData: action.payload
            }
        case SET_ALL_INSTITUTION_DROPDOWN:
            return {
                ...state,
                institutionDropdownListData: action.payload
            }
        case SET_ALL_INSTITUTION_PAGE_NO_COUNTER:
            return {
                ...state,
                institutionPageNoCounter: action.payload
            }
        case SET_INSTITUTION:
            return {
                ...state,
                institutionData: action.payload
            }
        case SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN:
            return {
                ...state,
                administrativeDepartmentData: action.payload
            }
        case GET_GRIEVANCE_LIST_WITH_PAGINATION:
            return {
                ...state,
                grievanceList: action.payload
            }
        case SET_ADMIN_GRIEVANCE_SINGLE_LIST:
            return {
                ...state,
                singleGrievanceDetail: action.payload,
            };
        case SET_ADMIN_NAVIGATION_SIDEBAR_PANEL:
            return {
                ...state,
                navigationpanelList: action.payload,
            };
        case SET_REPORT_RANGE:
            return {
                ...state,
                reportRange: action.payload,
            };
        default:
            return state;
    }
}